import React from 'react';
import styled from 'styled-components';
import { 
  FaMapMarkerAlt, 
  FaBuilding, 
  FaSwimmingPool, 
  FaUserTie, 
  FaBus, 
  FaUsers 
} from 'react-icons/fa';

const FeatureRatings = ({ featureAverages }) => {
  const categoryIcons = {
    location_connectivity: <FaMapMarkerAlt />,
    construction_quality: <FaBuilding />,
    amenities_facilities: <FaSwimmingPool />,
    developer_credibility: <FaUserTie />,
    public_transport: <FaBus />,
    community_vibe: <FaUsers />
  };

  if (!featureAverages) return null;

  // Split features into two groups of 3
  const features = Object.entries(featureAverages);
  const firstRow = features.slice(0, 3);
  const secondRow = features.slice(3, 6);

  return (
    <Container>
      <Title>Ratings by Features</Title>
      
      <FeaturesGrid>
        <FeatureRow>
          {firstRow.map(([category, average]) => (
            <FeatureCard key={category}>
              <FeatureIcon>
                {categoryIcons[category] || <FaMapMarkerAlt />}
              </FeatureIcon>
              <RatingValue>{average.toFixed(1)}</RatingValue>
              <ProgressTrack>
                <ProgressFill width={`${(average / 5) * 100}%`} />
              </ProgressTrack>
              <FeatureName>
                {category.split('_').map(word => 
                  word.charAt(0).toUpperCase() + word.slice(1)
                ).join(' ')}
              </FeatureName>
            </FeatureCard>
          ))}
        </FeatureRow>

        <FeatureRow>
          {secondRow.map(([category, average]) => (
            <FeatureCard key={category}>
              <FeatureIcon>
                {categoryIcons[category] || <FaMapMarkerAlt />}
              </FeatureIcon>
              <RatingValue>{average.toFixed(1)}</RatingValue>
              <ProgressTrack>
                <ProgressFill width={`${(average / 5) * 100}%`} />
              </ProgressTrack>
              <FeatureName>
                {category.split('_').map(word => 
                  word.charAt(0).toUpperCase() + word.slice(1)
                ).join(' ')}
              </FeatureName>
            </FeatureCard>
          ))}
        </FeatureRow>
      </FeaturesGrid>
    </Container>
  );
};

// Updated styling for grid layout
const Container = styled.div`
  margin-top: 1.5rem;
`;

const Title = styled.h4`
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 0.75rem;
  font-weight: 500;
`;

const FeaturesGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const FeatureRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
`;

const FeatureCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding: 0.5rem;
  background: #f8fafc;
  border-radius: 6px;
`;

const FeatureIcon = styled.div`
  font-size: 1.1rem;
  color: #4a6bff;
  margin-bottom: 0.4rem;
`;

const RatingValue = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.25rem;
`;

const ProgressTrack = styled.div`
  width: 100%;
  height: 3px;
  background: #eaeef5;
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 0.25rem;
`;

const ProgressFill = styled.div`
  height: 100%;
  background: #4a6bff;
  width: ${props => props.width};
  border-radius: 2px;
  transition: width 0.3s ease;
`;

const FeatureName = styled.span`
  font-size: 0.65rem;
  color: #666;
  text-align: center;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export default FeatureRatings;